export default __webpack_public_path__ + "static/2-4--d08f914ea9b7e519fda783a41c5d4003.png";